import React from 'react';
import { IconProps } from '../types/types';

const PLX: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#131419"/><path fillRule="evenodd" clipRule="evenodd" d="m13.095 5-2.717 3.703v2.695l2.704 3.69h3.793l-3.782-5.038L16.873 5h-3.778Z" fill="#fff"/><path fillRule="evenodd" clipRule="evenodd" d="m6.906 5 2.716 3.703v2.695l-2.704 3.69H3.125l3.782-5.038L3.127 5h3.779Z" fill="#EF9933"/></svg>
);

export default PLX;
